import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CSS from './GhostBtn.scss';
const GhostButton = ({ children, onClick, className, style = {}, disabled = false, onMouseEnter, onMouseLeave }) => {
    const classes = [CSS.GhostBtn, className ? className : ''];
    return (_jsx("button", { style: { ...style }, className: classes.join(' '), disabled: disabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: (e) => {
            if (onClick)
                onClick(e);
        }, children: children }));
};
export default GhostButton;
